import { Text } from "@/components/ui"

type HelpHintProps = {
  message?: string
}

export function HelpHint({ message }: HelpHintProps) {
  if (!message) return null
  return (
    <Text role="status" size="base" weight="semibold" tone="primary" align="center" className="mb-2">
      {message}
    </Text>
  )
}
